/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function () {

	const VIS_PREVIEW_ID = 'visualizationPreview';
	const SCHEMATICS_ID = 'com.ibm.vis.schematicsPreview';
	const VIS_IDS = [
		VIS_PREVIEW_ID,
		SCHEMATICS_ID
	];

	class CustomVizService {
		/**
		 * The dashboard was just saved, we need to send a speocial notification for custom visualization.
		 * @param {boolean} options.saveAs Boolean to let us know if it was a saveAs or save operations
		 * @param {object} options.resaveDashboardSpecCallback  Callback to re-save the dashboard spec. Used if the model gets updated
		 * @param {object} options.spec
		 * @param {object} options.context context to use to show the warning toast message
		 * @param {object} options.stringResources stringResources to fetch the warning meassage
		 */
		onDashboardSave(options) {
			const { spec, stringResources } = options;
			const { showToast } = options.context.glassContext.appController;

			if (this._findVisId(spec.layout.items)) {
				showToast(stringResources.get('customVizSaveWarning'), { type: 'warning' });
			}
		}

		_findVisId(items) {
			for (let i=0; i<items.length; i++) {
				const item = items[i];
				if (item.items) {
					return this._findVisId(item.items);
				} else {
					if (item.features) {
						const feature = item.features.Models_internal;
						if (feature &&
							feature.visId &&
							VIS_IDS.includes(feature.visId)
						) {
							return true;
						}
					}
				}
			}

			return false;

		}
	}
	return CustomVizService;
});
